export default "__VITE_ASSET__9c49c34e__"